<template>
    <div id="impressum" class="overlay">
      <div class="bg-white">
        <h2>Impressum</h2>
        <a class="close" href="#">&times;</a>
        <div>
          <h3>Herausgeber</h3>

          <p>Joachim Herz Stiftung<br>
            Langenhorner Chaussee 384<br>
            22419 Hamburg<br>
            <a href="http://www.joachim-herz-stiftung.de" target="blank">www.joachim-herz-stiftung.de</a>
            <br><br>
            © Joachim Herz Stiftung, 2017<br>
            Alle Rechte vorbehalten.<br>

            <h3>Produktion</h3>
            C.C. Buchner Verlag<br>
            <br>
            <h3>Programmierung und Design</h3>
            dpa-infografik<br>
            <br>
            <h3>Zahlenmaterial</h3>
            Eurostat, Institut der deutschen Wirtschaft Köln
            </p>
          </div>
          
          <p></p>
        </div>
      </div>
  </template>


  <script>
    export default {
      name: 'overlays',
      mounted: function() {
        // console.log(this.$el)
      },
        // created: function () {
        //       window.addEventListener('keyup', function(event) {
        //         if (event.which === 27)
        //           window.history.back();
        //       })
        // },
      data: function() {
        return {
        }
      }
    }
  </script>

<style lang="scss" src="./style.scss"></style>
  




// WEBPACK FOOTER //
// Overlays.vue?f5e9a19e